/**
 * CORE-1681 (QA george 31.10.2026) — the page to come back to after signing in, as a web
 * path. The return path used to be built from `pathname + search` only, and the fragment
 * carried the target: a push about a mention opens
 * `/u/{masterUserId}#communityChat/{discussionId}/{messageId}`, a guest signs in from there,
 * and came back to `#communityChat` — the general chat, the discussion and the message
 * gone. The fragment is part of the destination for every hash-routed surface («Мои
 * Live-сессии» `#rooms/…`, «Путь Света» `#lightPath`, the master's chats), so it rides along.
 *
 * The sign-in and sign-up pages themselves are never a destination: coming back to the
 * form would only send the person away again.
 */
export interface WebLocationLike { pathname: string; search: string; hash: string }

const AUTH_PAGES = /^\/(login|register|signin|signup)(\/|$)/;

export function webReturnToFrom(loc: WebLocationLike): string | undefined {
  if (!loc.pathname || !loc.pathname.startsWith('/') || AUTH_PAGES.test(loc.pathname)) return undefined;
  return `${loc.pathname}${loc.search || ''}${loc.hash || ''}`;
}

/** The current page on web; `undefined` on native or off an auth page. */
export function currentWebReturnTo(): string | undefined {
  if (typeof window === 'undefined' || !window.location) return undefined;
  return webReturnToFrom(window.location);
}
